module.exports = __webpack_public_path__ + "static/media/copy-outline.711ac849.svg";